module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--home"
  }, [_c('div', {
    staticClass: "gradient-bg"
  }), _vm._v(" "), _vm._l((_vm.components), function(component, index) {
    return _c(component, {
      key: index,
      tag: "component"
    })
  }), _vm._v(" "), _c('ui-footer')], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27c4e6e5"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/UnderstandingYourReport.vue
// module id = 310
// module chunks = 0